import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LifeTimeOnboardingDataInterface } from '../../models/dashboard/companyInsight/liftTimeOnboardingData';

interface IInitialState {
  lifeTimeOnboardingStatsData?: LifeTimeOnboardingDataInterface[];
}

const initialState: IInitialState = {
  lifeTimeOnboardingStatsData: undefined
};

const lifeTimeOnboardingDataSlice = createSlice({
  name: 'lifeTimeOnboardingDataSlice',
  initialState,
  reducers: {
    setLifeTimeOnboardingData(state, action: PayloadAction<LifeTimeOnboardingDataInterface[]>) {
      state.lifeTimeOnboardingStatsData = action.payload;
    },
  },
});

export const lifeTimeOnboardingDataActions = lifeTimeOnboardingDataSlice.actions;
export default lifeTimeOnboardingDataSlice.reducer;
